import {Component, Input, OnInit} from '@angular/core';
import {NotificationsService, ProjectService} from '@catcore/services';
import {ProjectFeatureService} from '@catmodules/models/project-feature/services/project-feature.service';
import {ProjectFeature} from '@catmodules/models/project-feature/types';
import {ProjectUnitsService} from '@catmodules/models/project-units/services/project-units.service';
import {ProjectUnit} from '@catmodules/models/project-units/types';
import {Control} from '@catmodules/widgets/slide-in-modal/types';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {LinkItem, StyleType} from '@catui/types';
import {ConfirmationService} from 'primeng/primeng';

/**
 * This component provides a modal dialog container to display
 * - all FeatureUnits of a ProjectFeature
 *
 * It als provides the option to:
 * - initiate a process to delete the provided ProjectFeature
 *
 * This component is currently bound to be used in context of a modal dialog opened by the {@link ModalService}
 */
@Component({
  templateUrl: './feature.component.html',
})
export class FeatureComponent implements OnInit {

  @Input()
  set feature(value: ProjectFeature) {
    this._feature = value;
    this.title = `${this.defaultTitle} for: ${this._feature.name}`;
  }

  get feature(): ProjectFeature {
    return this._feature;
  }

  @Input()
  set featureUnits(values: ProjectUnit[]) {
    this._featureUnits = values;
    this.updateFeatureUnitLinkItems(values);
  }

  get featureUnits(): ProjectUnit[] {
    return this._featureUnits;
  }

  private readonly defaultTitle = 'Feature Details';

  title: string;
  styleType = StyleType;

  labels = {
    delete: 'Delete',
  };
  controls: Control[] = [
    {
      isEnabled: () => true,
      label: this.labels.delete,
      onClick: ($event) => this.remove($event),
      styleType: this.styleType.alert,
    },
  ];

  featureUnitLinkItems: LinkItem[];

  private _feature: ProjectFeature;
  private _featureUnits: ProjectUnit[];

  constructor(private confirmationService: ConfirmationService,
              private modal: ActiveModal,
              private projectUnitService: ProjectUnitsService,
              private projectService: ProjectService,
              private projectFeatureService: ProjectFeatureService,
              private notificationsService: NotificationsService) {
  }

  ngOnInit() {
  }

  /**
   * Initiate a delete request.
   * Regardless if successful or not the current project will be refreshed afterwards to also refresh the related gui zone and unit
   * information of a project.
   *
   * @param $event
   */
  remove($event) {
    const featureName = this.feature.name;
    this.confirmationService.confirm({
      message: 'Do you really want to remove this Project Feature?',
      accept: () => {
        this
          .projectFeatureService
          .delete(this.feature)
          .subscribe(() => {
            this.notificationsService.success('Removed feature', `Successfully removed project feature: ${featureName}`);
            this.projectService.refreshCurrent();
            this.modal.close();
          });
      },
    });
  }

  private updateFeatureUnitLinkItems(values: ProjectUnit[]) {
    const items: LinkItem[] = [];
    values.forEach((item: ProjectUnit) => {
      const unitLabel = this.projectUnitService.getNameForUnit(item);
      items.push({label: unitLabel, navigate: null});
    });
    this.featureUnitLinkItems = items;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/feature/feature.component.ts